module.exports = __webpack_public_path__ + "static/img/cyl_banner.bd8eaca.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cyl_banner.png
// module id = CXRH
// module chunks = 0